<template>
  <v-card elevation="1">
    <v-dialog
    v-model="actionsModal"
    max-width="50%"
  >
    <v-card class="popup-card" elevation="1">
      <v-card-title class="popupHeadline" style="font-size: 24px">
        <div class="d-flex align-center justify-between popupHeadline" style="width: 100%">
          <h5> {{ announcement.Title || "" }}</h5>
          <v-icon @click="actionsModal = false" class="ml-auto" color="gray">mdi-close</v-icon>
        </div>
      </v-card-title>
      <v-divider class="mb-4" />
      <v-card-text>
        <p>{{ announcement.Description }}</p>

        <div>
          <h3 style="color: black" class="mb-2">{{ $t('labels.filesHr') }}</h3>
          <div class="d-flex flex-row align-center">
            <v-icon class="mr-1">mdi-file</v-icon>
            <h4><a target="_blank" :href="announcement.FileUrl">{{ $t('titles.attachedAnnouncementFile') }}</a></h4>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
    <v-card-title class="d-flex flex-row" style="color: var(--darkBlue)">
      <v-row>
        <v-col class="text-lg-left text-center" lg="12" cols="12">
          <h3>{{ $t('navigationDrawerMenu.customerAnnouncements') }}</h3>
        </v-col>
      </v-row>
      <div>
        <RefreshButton :refreshFunction="getItems"></RefreshButton>
      </div>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        hide-default-footer
        :loading="$store.state.loadingStatus"
        :options="{
          itemsPerPage: itemsPerPage,
        }"
        :item-key="'Id'"
        :no-data-text="$t('messages.noData')"
        :item-class="item => item.IsRead ? '' : 'activeItem'"
      >
        <template v-slot:footer>
          <div class="d-flex justify-center mt-8">
            <v-row align="center" justify="center">
              <v-col
                v-if="
                  $vuetify.breakpoint.md ||
                  $vuetify.breakpoint.lg ||
                  $vuetify.breakpoint.xl
                "
                md="2"
              ></v-col>
              <v-col cols="9" sm="12" md="7" lg="7" xl="7">
                <v-pagination
                  v-if="pageLength > 0"
                  class="my-4"
                  @input="onPageChange"
                  v-model="page"
                  :length="pageLength"
                  :total-visible="10"
                  circle
                ></v-pagination>
              </v-col>
              <v-col
                cols="11"
                sm="11"
                md="3"
                lg="3"
                xl="3"
                class="ml-md-auto d-flex align-center mb-6 mb-md-0 pr-3 pr-md-6"
              >
                <v-select
                  v-model="itemsPerPage"
                  :items="perPageValues"
                  :label="$t('labels.selectItemsPerPage')"
                  item-value="value"
                  item-text="name"
                  outlined
                  dense
                  @change="changeItemsPerPage"
                  rounded
                >
                </v-select>
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:no-data>
          <div class="my-10 d-flex flex-column align-center">
            <h4>{{ $t('messages.noData') }}</h4>
          </div>
        </template>
        <template v-slot:item.Description="{ item }">
          {{ `${item.Description.substring(0, 50)}${item.Description.length >= 50  ? '...' : ''}` }}
        </template>
        <!-- eslint-disable -->
        <template v-slot:item.CreatedOnUtc="{ item }">
          {{ item.CreatedOnUtc ? convertToLocal(item.CreatedOnUtc) : '-' }}
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-start">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  color="#29B7B7"
                  class="mr-1"
                  style="font-size: 20px"
                  v-bind="attrs"
                  v-on="on"
                  @click="viewAnnouncement(item)"
                >
                  mdi-eye
                </v-icon>
              </template>
              <span class="text-uppercase">{{ $t('buttons.view') }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.FileUrl" top>
              <template v-slot:activator="{ on, attrs }">
                <a :href="item.FileUrl" target="_blank">
                  <v-icon
                    small
                    class="mr-2 green-icon"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-download
                  </v-icon>
                </a>
              </template>
              <span>{{ $t('buttons.download') }}</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card-text>
    
  </v-card>
</template>
<script>
import {
  downloadFile,
  ITEMS_PER_PAGE_OPTIONS,
removeNullValues,
} from '../utils/constants';
import FormElement from '../components/FormElement.vue';
import formatDate from '../utils/formatDate';
import RefreshButton from '../components/RefreshButton.vue';
import TabScreen from '../components/TabScreen.vue';
import AnnouncementService from '../services/AnnouncementService';

export default {
  data() {
    return {
      companies: [],
      headers: [],
      items: [],

      // States
      itemsPerPage: 10,
      page: 1,
      totalItems: 0,
      perPageValues: [
        {
          name: '5',
          value: 5,
        },
        {
          name: '10',
          value: 10,
        },
        {
          name: '15',
          value: 15,
        },
        {
          name: '30',
          value: 30,
        },
        {
          name: '50',
          value: 50,
        },
        {
          name: '100',
          value: 100,
        },
        {
          name: this.$t('labels.All'),
          value: 9999,
        },
      ],

      actionsModal: false,

      file: {
        data: null,
        url: null
      },

      announcement: {}
    };
  },
  components: { FormElement, RefreshButton, TabScreen },
  mounted() {
    this.itemsPerPageOptions = ITEMS_PER_PAGE_OPTIONS;
    this.setup();
  },
  computed: {
    pageLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },
  methods: {
    downloadFile,
    viewAnnouncement(item){
      this.actionsModal = true
      this.isEditMode = true

      const isRead = item.IsRead;

      item.IsRead = true;
      this.announcement = Object.assign({}, item)

      
      if(!isRead){
        AnnouncementService.markAsRead(item)
        .catch(window.showError)
      }

    },

    changeItemsPerPage() {
      this.page = 1;
      this.getItems();
    },

    /**
     * Trigger when page changed.
     */
    onPageChange() {
      this.getItems();
    },

    async setup() {
      this.getItems();
      this.headers = [
        {
          text: this.$t('labels.titleHr'),
          value: 'Title',
          sortable: false,
          groupable: false,
          cellClass: 'regular-cell',
          align: 'center',
        },
        {
          text: this.$t('labels.description'),
          value: 'Description',
          sortable: false,
          groupable: false,
          cellClass: 'regular-cell',
        },
        {
          text: this.$t('titles.announcementDate'),
          value: 'CreatedOnUtc',
          sortable: false,
          groupable: false,
          cellClass: ['regular-cell'],
          align: 'center',
        },
        {
          text: this.$t('title.tableHeaderActions'),
          value: 'actions',
          sortable: false,
        }
      ];
    },

    /**
     * Get search history from service.
     */
    getItems() {
      this.$store.state.loadingStatus = true;
      AnnouncementService.getAnnouncements({
        Page: this.page,
        PageSize: this.itemsPerPage
      })
      .then((response) => {
        this.items = response.data.Result;
        this.totalItems = response.data.TotalItems;
      })
      .catch(window.showError)
      .finally(() => {
        this.$store.state.loadingStatus = false;
      });
    },

    submitForm(){
      this.$store.state.loadingStatus = true;
      let body = removeNullValues(this.form), requestFunction = null;

      try {
        if(this.isEditMode){
          requestFunction = AnnouncementService.update;
          body = {
            Id: body.Id,
          }
        }
        else{
          requestFunction = AnnouncementService.add;
        }

        if(requestFunction){
          requestFunction(body)
          .then(response => {
            window.showSuccess(this.$t(`messages.${this.isEditMode ?'successfulUpdateGeneral' : 'successfulAddGeneral'}`))
            this.actionsModal = false;
            this.getItems();
          })
          .catch(window.showError)
          .finally(() => {
            this.$store.state.loadingStatus = false;
          })

        }
      } catch (error) {
        window.showError(error);
      }
    },
  },
};
</script>
<style>
.activeItem{
  background-color: rgb(230, 230, 230);
}
</style>
